export const FETCH_REQUEST = 'supplier/FETCH_REQUEST';
export const FETCH_SUCCESS = 'supplier/FETCH_SUCCESS';

export const RESET = 'supplier/RESET';

export const FETCH_MEMBERS_REQUEST = 'supplier/FETCH_MEMBERS_REQUEST';
export const FETCH_MEMBERS_SUCCESS = 'supplier/FETCH_MEMBERS_SUCCESS';
export const FETCH_MEMBERS_ERROR = 'supplier/FETCH_MEMBERS_ERROR';

export const UPDATE_TEAM_MEMBER_REQUEST = 'supplier/UPDATE_TEAM_MEMBER_REQUEST';
export const UPDATE_TEAM_MEMBER_SUCCESS = 'supplier/UPDATE_TEAM_MEMBER_SUCCESS';
export const UPDATE_TEAM_MEMBER_ERROR = 'supplier/UPDATE_TEAM_MEMBER_ERROR';

export const CREATE_TEAM_MEMBER_REQUEST = 'supplier/CREATE_TEAM_MEMBER_REQUEST';
export const CREATE_TEAM_MEMBER_SUCCESS = 'supplier/CREATE_TEAM_MEMBER_SUCCESS';
export const CREATE_TEAM_MEMBER_ERROR = 'supplier/CREATE_TEAM_MEMBER_ERROR';

export const DELETE_TEAM_MEMBER_REQUEST = 'supplier/DELETE_TEAM_MEMBER_REQUEST';
export const DELETE_TEAM_MEMBER_SUCCESS = 'supplier/DELETE_TEAM_MEMBER_SUCCESS';
export const DELETE_TEAM_MEMBER_ERROR = 'supplier/DELETE_TEAM_MEMBER_ERROR';

export const GET_TEAM_MEMBERS_REQUEST = 'supplier/GET_TEAM_MEMBERS_REQUEST';
export const GET_TEAM_MEMBERS_SUCCESS = 'supplier/GET_TEAM_MEMBERS_SUCCESS';
export const GET_TEAM_MEMBERS_ERROR = 'supplier/GET_TEAM_MEMBERS_ERROR';

export const GET_TEAM_MEMBER_SUCCESS = 'supplier/GET_TEAM_MEMBER_SUCCESS';
export const GET_TEAM_MEMBER_ERROR = 'supplier/GET_TEAM_MEMBER_ERROR';

export const CREATE_TEAM_MEMBER = 'supplier/CREATE_TEAM_MEMBER';

export const TEAM_MEMBER_INVITE_RESEND_REQUEST =
  'supplier/TEAM_MEMBER_RESEND_REQUEST';
export const TEAM_MEMBER_INVITE_RESEND_ERROR =
  'supplier/TEAM_MEMBER_RESEND_ERROR';
export const TEAM_MEMBER_INVITE_RESEND_SUCCESS =
  'supplier/TEAM_MEMBER_RESEND_SUCCESS';

export const SEND_VERIFICATION_EMAIL_REQUEST =
  'supplier/SEND_VERIFICATION_EMAIL_REQUEST';
export const SEND_VERIFICATION_EMAIL_SUCCESS =
  'supplier/SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_ERROR =
  'supplier/SEND_VERIFICATION_EMAIL_ERROR';

export const CHECK_EMAIL_VERIFICATION_REQUEST =
  'supplier/CHECK_EMAIL_VERIFICATION_REQUEST';
export const CHECK_EMAIL_VERIFICATION_SUCCESS =
  'supplier/CHECK_EMAIL_VERIFICATION_SUCCESS';
export const CHECK_EMAIL_VERIFICATION_ERROR =
  'supplier/CHECK_EMAIL_VERIFICATION_ERROR';
